import React, {useState} from 'react'
import useStyles from './styles'
import {Grid} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import messages from './messages'
import ConfirmationModal from '../Common/ConfirmationModal'

export default function Footer() {
    const classes = useStyles()
    const {langLinks, footerBottomActions, translationDisclaimer} = messages
    const [modal, setModal] = useState({title: translationDisclaimer, dialogTitle: 'Translation Disclaimer', open: false})
    return (
        <div >
            <div className={classes.footerPrimary}>
                <Grid container className={classes.primaryTop}>
                    <Grid className={classes.topLinksWrapper} container item>
                        <Button
                        component="a"
                        className={classes.primaryTopLink1}
                        disableRipple
                        target="_blank"
                        rel="noopener noreferrer"
                        href='https://www.dhcs.ca.gov/Pages/Language_Access.aspx'>
                            Non-Discrimination Policy and Language Access
                        </Button>
                        <Button
                        component="a"
                        className={classes.primaryTopLink2}
                        disableRipple
                        target="_blank"
                        rel="noopener noreferrer"
                        href='https://www.dhcs.ca.gov/Pages/Health_Care_Language_Assistance_Services.aspx'>
                            Access Health Care Language Assistance Services (SB 223)
                        </Button>
                    </Grid>
                    <Grid className={classes.langLinksWrapper} container item>
                        { langLinks.map( (link, i) => 
                            <Grid key={i} item>
                                <Button
                                component="a"
                                className={classes.langLinks}
                                disableRipple
                                target="_blank"
                                href={link.to}>
                                    {link.text}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </div>
            <div className={classes.footerSecondary}>
                <Grid className={classes.bottomLinkWrapper} container justify='center'>
                    { footerBottomActions.map( (e, i) => 
                        <Grid key={i} item >
                            <Button
                            component="a"
                            className={classes.footerBottomLinks}
                            disableRipple
                            onClick={e.action ? () => e.action(setModal) : null}
                            target="_blank"
                            href={e.link}>
                                {e.text}
                            </Button>
                        </Grid>
                    )}
                </Grid>
            </div>
            <ConfirmationModal 
                open={modal.open}
                title={modal.title}
                dialogTitle={modal.dialogTitle}
                isWarning={false}
                confirm={() => setModal( prev => ({...prev, open: false}))}
                confirmText={'Close'}
            />
        </div>
    )
}